import { formatDayMonthYear } from '../../lib/format';
import { stepChartLabel, type StepSegment, type ThresholdCopy } from './thresholdModel';
import styles from './settings.module.css';

export function StepChart({ segments, copy }: { segments: StepSegment[]; copy: ThresholdCopy }) {
  return (
    <div className={styles.stepChart} role="img" aria-label={stepChartLabel(segments, copy)} data-sport={copy.sport}>
      {segments.map((segment) => (
        <div key={segment.id} className={styles.segment} data-current={segment.current}>
          <span className={styles.segmentValue}>{segment.label}</span>
          <span className={styles.segmentBar} style={{ height: segment.heightPx }} />
          <span className={styles.segmentDate}>{formatDayMonthYear(segment.effectiveFrom)}</span>
        </div>
      ))}
    </div>
  );
}
